import React, { useContext, useCallback } from 'react';
import { ISubcategoryContext, SubcategoryContext } from '../subcategoryState/subcategoryContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalSelectCustomer } from 'components/ModalWindows/ModalSelectCustomer';
import { ModalAssignSubcategoryToRestaurants } from 'components/ModalWindows/ModalAssignSubcategoryToRestaurants';

export const ModalWindows: React.FC = () => {
	const {
		refetchData,
		deleteSelectedItem,
		changeTypeOfModalWindow,
		setIDCustomer,
		toggleRememberMyChoice,
		rememberMyChoice,
		typeOfModalWindow,
		IDForAssignRestaurants,
		IDSelectedCustomer,
		isInitializedSelectCustomerModal,
	} = useContext<ISubcategoryContext>(SubcategoryContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModal = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchData(true);
	}, [changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingSubcategory');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !IDSelectedCustomer}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirm
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="deleteSubcategory"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="deleteSubcategorySuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorWhileDeletingSubcategory"
				/>
			)}
			{typeOfModalWindow === 'errorUpdatingSubcategory' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingSubcategory"
				/>
			)}
			{!IDSelectedCustomer && isInitializedSelectCustomerModal && (
				<ModalSelectCustomer
					setIDCustomer={setIDCustomer}
					toggleRememberMyChoice={toggleRememberMyChoice}
					rememberMyChoice={rememberMyChoice}
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && IDForAssignRestaurants && (
				<ModalAssignSubcategoryToRestaurants
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseAssignRestaurantsModal}
					onShowError={handleCloseAssignRestaurantsModalWithError}
					subcategoryId={IDForAssignRestaurants}
				/>
			)}
		</ModalWrapper>
	);
};
